// src/utils/scheduleUtils.js

export function getStatusChipProps(statusRaw) {
  const s = (statusRaw || "").toString().trim().toLowerCase();

  // Normalize variants coming from backend
  const status =
    s === "reception confirmed" ? "delivered" :
    s === "confirmed" ? "delivered" :
    s === "received" ? "delivered" :
    s === "overdue" ? "late" :
    s;

  const STATUS_CONFIG = {
    pending: {
      labelKey: "schedule.statusChips.pending",
      fallback: "PENDING YOUR CONFIRMATION",
      color: "warning",
      variant: "filled",
      hasAlert: true,
    },
    scheduled: {
      labelKey: "schedule.statusChips.scheduled",
      fallback: "SCHEDULED",
      color: "info",
      variant: "filled",
    },
    delivered: {
      labelKey: "schedule.statusChips.delivered",
      fallback: "RECEIVED",
      color: "success",
      variant: "filled",
    },
    late: {
      labelKey: "schedule.statusChips.late",
      fallback: "LATE",
      color: "error",
      variant: "filled",
    },
    cancelled: {
      labelKey: "schedule.statusChips.cancelled",
      fallback: "CANCELLED",
      color: "default",
      variant: "outlined",
    },
    canceled: {
      labelKey: "schedule.statusChips.cancelled",
      fallback: "CANCELLED",
      color: "default",
      variant: "outlined",
    },
  };

  return (
    STATUS_CONFIG[status] || {
      labelKey: "schedule.statusChips.unknown",
      fallback: "UNKNOWN",
      color: "default",
      variant: "outlined",
    }
  );
}



export function formatQuantity(value) {
  if (value == null || value === "") return "—";
  const n = Number(value);
  if (Number.isNaN(n)) return String(value);
  return n.toFixed(2);
}

export function normalizeStatusForCalendar(statusRaw) {
  const s = String(statusRaw || "").toLowerCase();
  if (s.includes("late")) return "late";
  if (s.includes("deliver")) return "delivered";
  if (s.includes("schedule")) return "scheduled";
  if (s.includes("cancel")) return "pending";
  if (s.includes("new entry") || s === "new" || s.includes("pending"))
    return "pending";
  return "pending";
}

export function toYMD(value) {
  if (!value) return null;

  const raw = String(value);

  const m = raw.match(/^(\d{4})-(\d{2})-(\d{2})/);
  if (m) return `${m[1]}-${m[2]}-${m[3]}`;

  const d = new Date(raw);
  if (Number.isNaN(d.getTime())) return null;

  const looksUTC = raw.includes("GMT") || raw.endsWith("Z") || raw.includes("T");

  const y = looksUTC ? d.getUTCFullYear() : d.getFullYear();
  const mo = (looksUTC ? d.getUTCMonth() : d.getMonth()) + 1;
  const day = looksUTC ? d.getUTCDate() : d.getDate();

  const mm = String(mo).padStart(2, "0");
  const dd = String(day).padStart(2, "0");
  return `${y}-${mm}-${dd}`;
}

export function formatDate(value) {
  const ymd = toYMD(value);
  if (!ymd) return "—";

  // parse as local date to avoid timezone shift
  const [y, m, d] = ymd.split("-").map(Number);
  const date = new Date(y, m - 1, d);
  if (Number.isNaN(date.getTime())) return ymd;

  try {
    return new Intl.DateTimeFormat(undefined, {
      month: "short",
      day: "numeric",
      year: "numeric",
    }).format(date);
  } catch {
    return ymd;
  }
}

export function getDonorScheduleYMD(row) {
  return toYMD(row?.scheduledDate);
}

export function getDonorTimeWindow(row) {
  const tw = row?.timeWindow;
  if (!tw || tw === "—") return null;
  return String(tw);
}
